import { useAllQueryParamValues } from './useAllQueryParamValues';

export function useQueryParam(name: string): string | undefined {
	const values = useAllQueryParamValues(name);

	if (Array.isArray(values)) return values[0];

	return typeof values === 'string' ? values : undefined;
}
